var modules_5e29803a = {"triggerButton":"MobileMenuBlock_module_triggerButton__03d08707","hidden":"MobileMenuBlock_module_hidden__03d08707","promoWrapper":"MobileMenuBlock_module_promoWrapper__03d08707","dropdown":"MobileMenuBlock_module_dropdown__03d08707","dropdownVisible":"MobileMenuBlock_module_dropdownVisible__03d08707"};
import "../../../assets/esm/components/MobileMenuBlock/src/MobileMenuBlock~zm3rW-f5.css";

export { modules_5e29803a as default };
//# sourceMappingURL=MobileMenuBlock.module.less.js.map
